import { Button, Modal } from '@mui/material';
import Loading from "components/Loading";
import React from "react";
import styled from "styled-components";
import SentryWrap from 'components/Sentry';
const CloseConfirmation = ({
  open,
  close,
  messageTitle = "",
  okButtonTitle = "Ok",
  cancelButtonTitle = "Cancel",
  actionOnOk = () => {},
  isLoading = false,
}) => {
  const onClickHandler = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    await actionOnOk();
    close();
  };
  return (
    <SentryWrap>
    <Modal open={open} onClose={close}>
      <ModalContent>
        {messageTitle}
        <ModalRow>
          <Button disabled={isLoading} style={{ marginRight: "4px" }} onClick={close}>
            {cancelButtonTitle}
          </Button>
          <Button
            color="secondary"
            variant="contained"
            type="button"
            onClick={onClickHandler}
          >
            {isLoading ? <Loading size={20} white /> : okButtonTitle}
          </Button>
        </ModalRow>
      </ModalContent>
    </Modal>
    </SentryWrap>
  );
};

export default CloseConfirmation;

const ModalContent = styled.div`
  align-items: center;
  background-color: #fff;
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 320px;
  padding: 16px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
`;
